import React, { useState } from 'react';
import { researchProjects } from '../../data/projects';
import { chapters } from '../../data/chapters'; // Import to get the chapter slug
import ResearchCard from '../ResearchCard';
import ProjectFilter from '../ProjectFilter';

const ChapterResearch = ({ chapterName }) => {
  const [selectedIndustry, setSelectedIndustry] = useState('All');

  // Get the full chapter object to access the slug
  const chapter = chapters.find(c => c.name === chapterName);
  const chapterSlug = chapter?.slug || '';

  // Filter only projects for the current chapter
  const chapterProjects = researchProjects.filter(project =>
    project.chapter === chapter.name &&
    project.status?.toLowerCase() !== 'completed'
  );

  // Create industry list from chapter's projects
  const industries = [
    'All',
    ...Array.from(new Set(
      chapterProjects.flatMap(p =>
        Array.isArray(p.industry) ? p.industry : [p.industry]
      )
    ))
  ];

  // Filter by industry within the chapter's projects
  const filteredProjects =
    selectedIndustry === 'All'
      ? chapterProjects
      : chapterProjects.filter(p =>
          Array.isArray(p.industry)
            ? p.industry.includes(selectedIndustry)
            : p.industry === selectedIndustry
        );

  return (
    <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
      <h1 className='huge-title'>Research Projects</h1>

      {/* Live Count */}
      <p className='subtitle'>
        <strong>{filteredProjects.length} / {researchProjects.length}</strong> projects shown
      </p>

      {/* Filter Button Group */}
      <ProjectFilter
        options={industries}
        selected={selectedIndustry}
        onSelect={setSelectedIndustry}
      />

      {/* Project Cards */}
      <div style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: '2rem',
        justifyContent: 'center',
        marginTop: '2rem',
      }}>
        {filteredProjects.map(project => (
          <ResearchCard
            key={project.slug}
            slug={project.slug}
            title={project.title}
            description={project.overview}
            status={project.status}
            people={project.people}
            group={project.group}
            orgs={project.orgs}
            advisors={project.advisors}
            chapterSlug={chapterSlug}
            chapter={project.chapter}
          />
        ))}
      </div>
    </div>
  );
};

export default ChapterResearch;
